/* eslint-disable array-callback-return */
// @ts-nocheck
import { useContext, Suspense, lazy } from 'react';
import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import Loading from './app/components/loading';

import './css/index.css';
import App from './App';
import './css/styles.css';

import { ActaAuthContext } from "./pa_kit/auth";


const AppRoutes = () => {

    const auth = useContext(ActaAuthContext);

    const theme = auth.theme;  

    const defaultTheme = {
        "--color-primary": theme.primary_color,
        "--color-secondary": theme.secondary_color,
        "--color-tertiary": theme.tertiary_color,
        "--color-quaternary": theme.quaternary_color,
    }    

    const applyTheme = (theme) => {
        Object.keys(theme).map((key) => {
            const value = theme[key];
            document.documentElement.style.setProperty(key, value);
        });
    };
    
    applyTheme(defaultTheme);

    //const localSettings = auth.localSettings;
    //const user = auth.user;


    const ModuleView = lazy(() => import('./app/modules/components/module'));
    const ModulesListView = lazy(() => import('./app/modules/components/list'));
    const RequestsListMineView = lazy(() => import('./app/requests/components/list_mine'));
    const RequestView = lazy(() => import('./app/requests/components/request'));
    const ServicesListView = lazy(() => import('./app/services/components/services_list'));
    const ServiceView = lazy(() => import('./app/services/components/service'));
    const PaymentResultView = lazy(() => import('./app/payments/components/payment_result'));
    const RequestsListView = lazy(() => import('./app/requests/components/list'));
    const LegalNotesiew = lazy(() => import('./app/policies/components/legal:notes'));
    const PrivacyPolicyView = lazy(() => import('./app/policies/components/provacy_policy'));
    const RequestsListWaitingProtocolView = lazy(() => import('./app/requests/components/list_waiting_protocol'));

    //const Dashboard = lazy(() => import('./admin/dashboard/dashboard'));
    //const Main = lazy(() => import('./admin/dashboard/main'));

    
    if(auth.isLoading) return <div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loading /></div>;
    return <>
        <BrowserRouter>
            <Suspense fallback={<div style={{ width: '100vw', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loading /></div>}>
              <Routes>
                                  {/**

                <Route path="/admin" element={(true || auth.user.hasPermissions()) ? <Dashboard /> : <Navigate to="/" />} >
                  <Route path="" element={<Main />} ></Route>
                  <Route path="pages" element={isActagovWebsiteEditor ? <PagesList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-page" element={isActagovWebsiteEditor ? <CreatePage /> : <Navigate to="/" />}></Route>
                  <Route path="edit-page/:pageSlug" element={isActagovWebsiteEditor ? <EditPage /> : <Navigate to="/" />}></Route>
                  <Route path="menus" element={isActagovWebsiteEditor ? <MenusList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-menu" element={isActagovWebsiteEditor ? <CreateMenu /> : <Navigate to="/" />}></Route>
                  <Route path="edit-menu/:menuID" element={isActagovWebsiteEditor ? <EditMenu /> : <Navigate to="/" />}></Route>
                  <Route path="categories" element={isActagovWebsiteEditor ? <CategoriesList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-category" element={isActagovWebsiteEditor ? <CreateCategory /> : <Navigate to="/" />} ></Route>
                  <Route path="edit-category/:categorySlug" element={isActagovWebsiteEditor ? <EditCategory /> : <Navigate to="/" />} ></Route>
                  <Route path="tags" element={isActagovWebsiteEditor ? <TagsList /> : <Navigate to="/" />} ></Route>
                  <Route path="edit-tag/:tagSlug" element={isActagovWebsiteEditor ? <EditTag /> : <Navigate to="/" />} ></Route>
                  <Route path="create-tag" element={isActagovWebsiteEditor ? <CreateTag /> : <Navigate to="/" />} ></Route>
                  <Route path="organization" element={isActagovWebsiteEditor ? <OrganizationData /> : <Navigate to="/" />} ></Route>
                  <Route path="structures" element={isActagovWebsiteEditor ? <StructuresList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-structure" element={isActagovWebsiteEditor ? <CreateStructure /> : <Navigate to="/" />} ></Route>
                  <Route path="edit-structure/:structureID" element={isActagovWebsiteEditor ? <EditStructure /> : <Navigate to="/" />} ></Route>
                  <Route path="sectors" element={isActagovWebsiteEditor ? <SectorsList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-sector" element={isActagovWebsiteEditor ? <CreateSector /> : <Navigate to="/" />} ></Route>
                  <Route path="edit-sector/:sectorID" element={isActagovWebsiteEditor ? <EditSector /> : <Navigate to="/" />} ></Route>
                  <Route path="offices" element={isActagovWebsiteEditor ? <OfficesList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-office" element={isActagovWebsiteEditor ? <CreateOffice /> : <Navigate to="/" />} ></Route>
                  <Route path="edit-office/:officeID" element={isActagovWebsiteEditor ? <EditOffice /> : <Navigate to="/" />} ></Route>
                  <Route path="staff" element={isActagovWebsiteEditor ? <StaffList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-staff" element={isActagovWebsiteEditor ? <CreateStaff /> : <Navigate to="/" />} ></Route>
                  <Route path="edit-staff/:staffID" element={isActagovWebsiteEditor ? <EditStaff /> : <Navigate to="/" />} ></Route>
                  <Route path="activities" element={isActagovWebsiteEditor ? <ActivitiesList /> : <Navigate to="/" />} ></Route>
                    */}
                  {/* <Route path="users" element={isActagovWebsiteEditor ? <UsersList /> : <Navigate to="/" />} ></Route> */}
                  {/* 
                  <Route path="settings" element={isActagovWebsiteEditor ? <Settings /> : <Navigate to="/" />} ></Route>
                  <Route path="profile" element={<Profile />} ></Route>
                  <Route path="news" element={isActagovContentEditor ? <NewsList /> : <Navigate to="/" />} ></Route>
                  <Route path="events" element={isActagovContentEditor ? <EventsList /> : <Navigate to="/" />} ></Route>
                  <Route path="documents" element={isActagovContentEditor ? <DocumentsList /> : <Navigate to="/" />} ></Route>
                  <Route path="create-news" element={isActagovContentEditor ? <CreateNews /> : <Navigate to="/" />}></Route>
                  <Route path="create-event" element={isActagovContentEditor ? <CreateEvent /> : <Navigate to="/" />}></Route>
                  <Route path="create-document" element={isActagovContentEditor ? <CreateDocument /> : <Navigate to="/" />}></Route>
                  <Route path="edit-news/:newsSlug" element={isActagovContentEditor ? <EditNews /> : <Navigate to="/" />}></Route>
                  <Route path="edit-event/:eventSlug" element={isActagovContentEditor ? <EditEvent /> : <Navigate to="/" />}></Route>
                  <Route path="edit-document/:documentSlug" element={isActagovContentEditor ? <EditDocument /> : <Navigate to="/" />}></Route>
                  <Route path="texts" element={isActagovWebsiteEditor ? <TextList /> : <Navigate to="/" />}></Route>
                  <Route path="create-text" element={isActagovWebsiteEditor ? <CreateText /> : <Navigate to="/" />}></Route>
                  <Route path="edit-text/:textID" element={isActagovWebsiteEditor ? <EditText /> : <Navigate to="/" />}></Route>
                  <Route path="galleries" element={isActagovWebsiteEditor ? <GalleriesList /> : <Navigate to="/" />}></Route>
                  <Route path="create-gallery" element={isActagovWebsiteEditor ? <CreateGallery /> : <Navigate to="/" />}></Route>
                  <Route path="edit-gallery/:galleryID" element={isActagovWebsiteEditor ? <EditGallery /> : <Navigate to="/" />}></Route>
                  <Route path="places" element={isActagovWebsiteEditor ? <PlacesList /> : <Navigate to="/" />}></Route>
                  <Route path="create-place" element={isActagovWebsiteEditor ? <CreatePlace /> : <Navigate to="/" />}></Route>
                  <Route path="edit-place/:placeSlug" element={isActagovWebsiteEditor ? <EditPlace /> : <Navigate to="/" />}></Route>
                  <Route path="custom-widgets" element={isActagovWebsiteEditor ? <CustomWidgetsList /> : <Navigate to="/" />}></Route>
                  <Route path="create-custom-widget" element={isActagovWebsiteEditor ? <CreateCustomWidget /> : <Navigate to="/" />}></Route>
                  <Route path="edit-custom-widget/:customWidgetID" element={isActagovWebsiteEditor ? <EditCustomWidget /> : <Navigate to="/" />}></Route>
                  <Route path="gdpr-registry" element={isActagovWebsiteEditor ? <GDPRRegistryList /> : <Navigate to="/" />} ></Route>
                  <Route path="page-evaluation" element={isActagovWebsiteEditor ? <PageEvaluationList /> : <Navigate to="/" />} ></Route>
                  <Route path="page-evaluation/*" element={isActagovWebsiteEditor ? <PageEvaluationDetail /> : <Navigate to="/" />} ></Route>
                  <Route path="filemanager" element={<FileManagerModal />} ></Route>
                </Route>
                  */}

                <Route path="/" element={<App />} >

                  <Route path="" element={<ServicesListView />} />
                  <Route path="services">
                    <Route path="" element={<ServicesListView />} />
                    <Route path=":slug" element={<ServicesListView />} />
                  </Route>
                  <Route path="service">
                    <Route path=":slug" element={<ServiceView />} />
                  </Route>
                  <Route path="topics">
                    {/*
                    <Route path="" element={<ServiceTopicsListView />} />
                    */}
                    <Route path=":slug" element={<ServicesListView />} />
                  </Route>
                  <Route path="module">
                    <Route path="new" element={<div>NEW MODULE</div>} />
                    <Route path=":moduleId" element={<ModuleView />} />
                  </Route>
                  <Route path="modules">
                    <Route path="" element={<ModulesListView />} />
                    <Route path=":categorySlug" element={<ModulesListView />} />
                  </Route>
                  <Route path="request">
                    <Route path="new/:requestId" element={<div>NEW request</div>} />
                    <Route path=":requestId/payments/:paymentOutcome" element={<RequestView />} />
                    <Route path=":requestId" element={<RequestView />} />
                  </Route>
                  <Route path="requests">
                    <Route path="" element={<RequestsListMineView />} />
                  </Route>
                  <Route path="manage">
                    <Route path="requests">
                      <Route path="" element={<RequestsListView />} />
                      <Route path="waiting-protocol" element={<RequestsListWaitingProtocolView />} />
                    </Route>
                  </Route>
                  <Route path="payments">
                    <Route path="result" element={<PaymentResultView />} />
                  </Route>
                  <Route path="note-legali" element={<LegalNotesiew />} />
                  <Route path="privacy-policy" element={<PrivacyPolicyView />} />
                </Route>
              </Routes>
            </Suspense>
        </BrowserRouter>
    </>;
}

export default AppRoutes;

        
        